<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2" cols="12">
          <div class="rowinfo">
            <v-text-field
              v-model="computedValue.name"
              :error-messages="errors.name"
              append-icon="mdi-rename-outline"
              class="rounded-lg"
              clearable
              dense
              :label="$t('name_field')"
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-name`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('name_field')"
            />
          </div>
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <color-picker
            v-model="computedValue.color"
            :label="$t('color')"
            size="100%"
          />
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <icon-picker
              v-model="computedValue.icon"
              input-class="rounded-lg"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-icon`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('icon')"
            />
          </div>
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <custom-date-picker
              v-model="computedValue.expire_at"
              :error-messages="errors.expire_at"
              :min="nowDateTimeString()"
              append-icon="mdi-calendar-range"
              dense
              hide-details
              :label="$t('end_date')"
              outlined
              wrapper-class="rounded-lg"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-expire_at`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('end_date')"
            />
          </div>
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <v-radio-group
            v-model="computedValue.status"
            class="ma-0 pa-0"
            dense
            mandatory
            row
          >
            <template v-slot:label>
              <div class="text-right">{{ $t("status") }}</div>
            </template>

            <v-radio
              v-for="item in statusItems"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            />
          </v-radio-group>
        </v-col>

        <v-col class="pa-2" cols="12">
          <pic-selector
            :edit-img="false"
            :edit-name="false"
            :field.sync="computedValue.picture"
            :default-cat-name="$t('TITTLES.ADMIN_CATEGORY')"
            one-pic
            single
          />
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import { debounce } from "@/main";
import IconPicker from "@/view/components/IconPicker.vue";

export default {
  name: "specialCategoryEditor",

  components: { IconPicker, PicSelector, CustomDatePicker, ColorPicker },

  props: {
    value: Object,
    errors: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "special-category-editor",
      // statusItems: [
      //   { value: "active", text: "فعال" },
      //   { value: "inactive", text: "غیرفعال" },
      // ],
    };
  },

  computed: {
    statusItems() {
      return [
        { value: "active", text: this.$t("active") },
        { value: "inactive", text: this.$t("inactive") },
      ];
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    canSubmit() {
      return !!this.computedValue.name && !!this.computedValue.color;
    },
  },

  watch: {
    computedValue: {
      deep: true,

      handler(val, oldVal) {
        debounce(() => {
          this.updateCategory();
        }, 5000);
      },
    },
  },

  methods: {
    updateCategory() {
      this.$api
        .post(`v1/testQr/category-special`, this.computedValue)
        .then(({ data }) => {
          console.log("special category has been updated: ", data);
          this.$root.$emit("fetchSpecialCategory");
        })
        .catch(({ response }) =>
          console.log("failed to update special category: ", response)
        );
    },
  },
};
</script>

<style scoped></style>
